import gql from 'graphql-tag';
import {
  SUCCESS_SMS_STATUSES,
  SENDING_SMS_STATUSES,
  ALL_SMS_STATUSES,
  TWILIO_UNSUBSCRIBED_ERROR_CODE,
  ALL_DIRECT_SND_SMS_STATUSES,
  DIRECT_SND_SMS_SUCCESS_STATUSES,
  DIRECT_SND_SMS_SUBMITTED_STATUSES,
} from 'src/constants/misc';

const ManualTextBatchWithAggregate = gql`
  fragment ManualTextBatchWithAggregate on ri_apps_prd_manual_text_batches {
    manual_text_batch_id
    name
    content
    organization_id
    media_url
    created_at
    send_at
    manual_text_batch_organization {
      organization_id
      name
      sms_provider
    }
    manual_text_batch_user {
      user_id
      first_name
      last_name
    }
    total_messages_count: manual_text_batch_manual_texts_aggregate {
      aggregate {
        count
      }
    }
    from: manual_text_batch_manual_texts(limit: 1) {
      from
    }
    all_statuses_messages_count: manual_text_batch_manual_texts_aggregate(
      where: { _or: [{ status: { _in: ${JSON.stringify(
        ALL_SMS_STATUSES
      )} }}, {direct_snd_status: { _in: ${JSON.stringify(ALL_DIRECT_SND_SMS_STATUSES)} } }] }
    ) {
      aggregate {
        count
      }
    }
    sent_messages_count: manual_text_batch_manual_texts_aggregate(
      where: { _or: [{ status: { _in: ${JSON.stringify(
        SUCCESS_SMS_STATUSES
      )} }}, {direct_snd_status: { _in: ${JSON.stringify(DIRECT_SND_SMS_SUCCESS_STATUSES)} } }] }
    ) {
      aggregate {
        count
      }
    }
    sending_messages_count: manual_text_batch_manual_texts_aggregate(
      where: { _or: [{ status: { _in: ${JSON.stringify(
        SENDING_SMS_STATUSES
      )} }}, {direct_snd_status: { _in: ${JSON.stringify(DIRECT_SND_SMS_SUBMITTED_STATUSES)} } }] }
    ) {
      aggregate {
        count
      }
    }
    unsubscribed_messages_count: manual_text_batch_manual_texts_aggregate(where: {twilio_error_code: {_eq: "${TWILIO_UNSUBSCRIBED_ERROR_CODE}"}}) {
      aggregate {
        count
      }
    }
    failed_messages_count: manual_text_batch_manual_texts_aggregate(
    where: { _or: [{ status: { _nin: ${JSON.stringify([
      ...SUCCESS_SMS_STATUSES,
      ...SENDING_SMS_STATUSES,
    ])} }}, {direct_snd_status: { _nin: ${JSON.stringify([
  ...DIRECT_SND_SMS_SUCCESS_STATUSES,
  ...DIRECT_SND_SMS_SUBMITTED_STATUSES,
])} } }] }
    ) {
      aggregate {
        count
      }
    }
  }
`;

const ManualText = gql`
  fragment ManualText on ri_apps_prd_manual_texts {
    manual_text_id
    from
    to
    date_sent
    status
    twilio_error_code
    direct_snd_status
    direct_snd_error
  }
`;

export const GET_MANUAL_TEXT_BATCH_AGGREGATES = gql`
  query getManualMessageTaskBatchesAggregate(
    $where: ri_apps_prd_manual_text_batches_bool_exp
    $textsWhere: ri_apps_prd_manual_texts_bool_exp
  ) {
    ri_apps_prd_manual_text_batches_aggregate(where: $where) {
      aggregate {
        count
      }
    }
    ri_apps_prd_manual_texts_aggregate(where: $textsWhere) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_MANUAL_TEXT_BATCH_REPORTS = gql`
  query getManualMessageTaskBatches(
    $where: ri_apps_prd_manual_text_batches_bool_exp
    $limit: Int
    $offset: Int
  ) {
    ri_apps_prd_manual_text_batches(
      where: $where
      limit: $limit
      offset: $offset
      order_by: { created_at: desc }
    ) {
      ...ManualTextBatchWithAggregate
    }
    ri_apps_prd_manual_text_batches_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
  ${ManualTextBatchWithAggregate}
`;

export const GET_MANUAL_TEXTS_AND_BATCH_BY_ID = gql`
  query getManualMessageTaskBatches($id: Int!, $textLimit: Int, $textOffset: Int) {
    ri_apps_prd_manual_text_batches_by_pk(manual_text_batch_id: $id) {
      ...ManualTextBatchWithAggregate
      manual_text_batch_manual_texts(limit: $textLimit, offset: $textOffset) {
        ...ManualText
      }
    }
  }
  ${ManualTextBatchWithAggregate}
  ${ManualText}
`;

// One page of a batch's recipients plus the unpaginated total, so the caller can render a
// pager without pulling every manual_text row into the browser.
export const GET_MANUAL_TEXTS_BY_BATCH_ID_PAGINATED = gql`
  query getManualTextsByBatchIdPaginated($id: Int!, $limit: Int!, $offset: Int!) {
    rows: ri_apps_prd_manual_texts(
      where: { manual_text_batch_id: { _eq: $id } }
      order_by: { manual_text_id: asc }
      limit: $limit
      offset: $offset
    ) {
      ...ManualText
    }
    total: ri_apps_prd_manual_texts_aggregate(where: { manual_text_batch_id: { _eq: $id } }) {
      aggregate {
        count
      }
    }
  }
  ${ManualText}
`;

export const GET_ALL_MANUAL_TEXTS_BY_BATCH_ID = gql`
  query getAllManualTextsByBatchId($id: Int!) {
    ri_apps_prd_manual_text_batches_by_pk(manual_text_batch_id: $id) {
      name
      manual_text_batch_manual_texts {
        ...ManualText
      }
    }
  }
  ${ManualText}
`;

export const GET_MANUAL_TEXT_BATCHES_FOR_DASHBOARD = gql`
  query getManualTextBatchesForDashboard($where: ri_apps_prd_manual_text_batches_bool_exp) {
    ri_apps_prd_manual_text_batches(where: $where, order_by: { created_at: desc }) {
      manual_text_batch_id
      name
      created_at
      send_at
      total_messages_count: manual_text_batch_manual_texts_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;
